import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { STORE } from "@/constants/testIds";
import { FAQ } from "@/data/content";

export const FaqAccordion = ({ items = FAQ, limit }) => {
  const list = typeof limit === "number" ? items.slice(0, limit) : items;
  return (
    <Accordion
      type="single"
      collapsible
      className="w-full"
      data-testid={STORE.faqAccordion}
    >
      {list.map((item, i) => (
        <AccordionItem
          key={item.q}
          value={`faq-${i}`}
          data-testid={`faq-item-${i}`}
          className="mb-3 rounded-2xl border border-[color:rgba(10,27,51,0.14)] bg-white px-2"
        >
          <AccordionTrigger
            data-testid={`faq-item-trigger-${i}`}
            className="px-4 text-left text-sm font-semibold text-[var(--ibp-ink)] hover:no-underline sm:text-base"
          >
            {item.q}
          </AccordionTrigger>
          <AccordionContent className="px-4 text-sm leading-6 text-[color:rgba(11,18,32,0.72)]">
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default FaqAccordion;
